export const allOrderStatuses = [
    'cancelled',
    'pending',
    'completed',
    'failed',
    'refunded',
]

export const OrdersStatuses = [
    'pending',
    'payment_pending',
    'processing',
    'completed',
    'cancelled'
]


export const OrderPaymentType = {
    cash: 'Наличные'
}